import { render, staticRenderFns } from "./PatientTermsAndPrivacyConstraint.vue?vue&type=template&id=639764a9&scoped=true"
import script from "./PatientTermsAndPrivacyConstraint.vue?vue&type=script&lang=js"
export * from "./PatientTermsAndPrivacyConstraint.vue?vue&type=script&lang=js"
import style0 from "./PatientTermsAndPrivacyConstraint.vue?vue&type=style&index=0&id=639764a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639764a9",
  null
  
)

export default component.exports